@if(eventhubConnectionStatus$ | async; as connectionStatus){
<div class="d-flex">
    @if(connectionStatus.lastError){
    <rask-icon
        icon="far fa-chain-broken error"
        popoverClass="popover-error popover-no-max-width">
        <div class="popover-message-container">
            <div class="popover-message">
                <div class="status-text">Eventhub: {{connectionStatus.state}}</div>
                <div>
                    {{connectionStatus.lastError}}
                </div>
            </div>
        </div>
    </rask-icon>
    }
</div>
}